import { jsx as _jsx } from "react/jsx-runtime";
import { BrComponent } from "./styles";
export function Br({ display = "block" }) {
    return _jsx(BrComponent, { "data-testid": `br-component-${display}`, display: display });
}
//# sourceMappingURL=index.js.map